import { RouteRecordRaw } from 'vue-router';
import { TrainingControlPage } from '@/pages/training';

export const routeName = 'TreinamentosControleTreinamento';

export const route: RouteRecordRaw = {
  path: 'treinamentos/lista-treinamentos/:id/controle-treinamento',
  name: routeName,
  component: TrainingControlPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Controle de Treinamento',
    breadcrumbTrail: [
      { name: 'Treinamentos', path: '/treinamentos' },
      { name: 'Lista de Treinamentos', path: '/treinamentos/lista-treinamentos' },
      { name: 'Controle de Treinamento' },
    ],
    permissions: [{ action: 'read', subject: 'Training' }],
  },
};
